import { observer } from 'mobx-react';
import * as React from 'react';
import FlashMessage from '../components/FlashMessage';
import { Anonymous, Unauthorized, type Errored } from '../CurrentUserStore/Types';
import { errorAlert } from '../Notifications/Types';

interface Props {
  state: Anonymous | Unauthorized | Errored;
}

const CurrentUserErrorMessage: React.FC<Props> = ({ state }) => {
  switch (state.kind) {
    case 'anonymous':
      return state.error
        .map((err) => <FlashMessage alert={errorAlert(err)} />)
        .getOrElse(() => <></>);
    case 'unauthorized':
    case 'errored':
      return <FlashMessage alert={errorAlert(state.error)} />;
  }
};

export default observer(CurrentUserErrorMessage);
